import React, { useState, useEffect, useContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import axios from '../../../../../api/axios';
import Progressbar from '../../../../../components/Progress/Progressbar';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import store from '../../../../../store';
import useTitle from 'hooks/useTitle';
import { NULL } from 'sass';
import { CircularProgress, FormHelperText, TextField } from '@material-ui/core';
import FreightsModal from './FreightsModal';
import useToast from 'hooks/useToast';
// import { AddCircleOutlineIcon } from '@material-ui/icons/AddCircleOutline';

const useStyles = makeStyles((theme) => ({
  driversSettings: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}));

const Freights = ({ config }) => {
  useTitle('تنظیمات باربری ها');
  const toast = useToast();
  const [freightModal, setFreightModal] = useState(false);
  const [choosedFreight, setChoosedFreight] = useState(null);
  const [loadingFreight, setLoadingFreight] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);

  const handleGetFreightSetting = async () => {
    try {
      setLoadingFreight(true);
      const { data } = await axios.get(`/api/v1/admin/settings/freights`);
      setChoosedFreight(data?.settings?.defaultFreight);
    } catch (error) {
      toast.error(error);
      console.error(error);
    } finally {
      setLoadingFreight(false);
    }
  };

  const handleSaveSettings = async () => {
    try {
      setLoadingSave(true);
      await axios.put(`/api/v1/admin/settings`, {
        settings: {
          defaultFreight: choosedFreight,
        },
        section: 'freights',
      });
      toast.success('تغییرات با موفقیت ثبت گردید.');
    } catch (error) {
      toast.error(error);
    } finally {
      setLoadingSave(false);
    }
  };
  useEffect(() => {
    handleGetFreightSetting();
  }, []);
  return (
    <FullCard title={config.name} category="کلیه تنظیمات مربوط به باربری ها">
      <FreightsModal
        openFreightsModal={freightModal}
        handleSelectFreight={(data) => setChoosedFreight(data?.[0]._id)}
        handleCloseOperatorDialog={() => setFreightModal(false)}
      />

      {!loadingFreight ? (
        <div className="row g-3">
          <div className="col-12 col-md-4">
            <TextField
              fullWidth
              size="small"
              value={choosedFreight}
              InputProps={{
                readOnly: true,
              }}
              name="freightId"
              variant="outlined"
              label="آی دی باربری پیش فرض سیستم"
            />
          </div>
          <div className="col-12 col-md-2">
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={() => setFreightModal(true)}
            >
              {!choosedFreight ? ' انتخاب باربری' : 'تغییر باربری'}
            </Button>
          </div>
          <div className="col-12 col-md-1">
            <Button
              fullWidth
              endIcon={loadingSave ? <CircularProgress size={10} /> : null}
              disabled={loadingSave}
              onClick={handleSaveSettings}
              variant="outlined"
              color="secondary"
            >
              ذخیره
            </Button>
          </div>
        </div>
      ) : (
        <div className="mt-4 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </div>
      )}
    </FullCard>
  );
};

export default Freights;
